import React from 'react';
import PropTypes from 'prop-types';
import Category from './category';
import { AppProvider } from './CategoryContext';
import './index.scss';

const CategoryPage = ({ isTouch, category, categorySlug, abTests }) => (
    <div className="category-page">
        <AppProvider isTouch={isTouch}>
            <Category category={category} categorySlug={categorySlug} abTests={abTests}/>
        </AppProvider>
    </div>
);

CategoryPage.propTypes = {
    category: PropTypes.object
};

export default CategoryPage;
